module.exports = __webpack_public_path__ + "img/management_delle_destinazioni.3d3cba4d.svg";